if (!customElements.get('delivery-scrolling-text')) {
  class DeliveryScrollingText extends HTMLElement {
    constructor() {
      super();
      if (!this.hasAttribute('height-reference')) return;
      this.onResize();
      this.bindOnResize = debounce(this.onResize.bind(this), 100);
      window.addEventListener('resize', this.bindOnResize);
    }

    onResize() {
      if (this.clientHeight > 0) {
        document.documentElement.style.setProperty('--shipping-message-height', `${this.clientHeight}px`);
      } else {
        document.documentElement.style.setProperty('--shipping-message-height', `0px`);
      }
    }
  }
  customElements.define('delivery-scrolling-text', DeliveryScrollingText);
}
